import { useState } from 'react';

import { useDocumentHooks } from '../../api/documents/hooks/useDocumentHooks';
import { EMPTY_ARR } from '../../constants';
import { useTenantedApplicationConfig } from '../../contexts';
import { useModuleScope } from '../../contexts/ModuleScopeContext';
import { AnyDocument } from '../../types';
import { useEventHandler } from '../useEventHandler';
import { UseHooksManager } from './types/useHooksManager';

export function useHooksManager(): UseHooksManager {
  const module = useModuleScope();
  const config = useTenantedApplicationConfig();
  const [rootDocument, setRootDocument] = useState<AnyDocument | null>(null);

  const statusDefinitionName = rootDocument
    ? config.documents[rootDocument.definition].modules[module].primaryWorkflow
        .statusDefinition
    : undefined;

  const { hooks: fetchedHooks } = useDocumentHooks(
    rootDocument?.id ?? '',
    rootDocument?.definition ?? '',
    statusDefinitionName,
    { enabled: rootDocument !== null },
  );

  const clearHooks = useEventHandler(() => {
    setRootDocument(null);
  });

  const fetchHooks = useEventHandler(async (doc: AnyDocument) => {
    setRootDocument(doc);
  });

  return {
    hooks: fetchedHooks ?? EMPTY_ARR,
    fetchHooks,
    clearHooks,
  };
}
